/*
 * svnty-cart-toast.js - THE CART FEEDBACK LAYER (night build wave 3, 2026-09-19).
 * Loaded once for the whole theme from snippets/svnty-head.liquid, deferred, no markup, no template.
 *
 * It owns three things, because on this store they are one thing:
 *   1. THE TOAST - the ONE .svnty-toast node, the sibling's sib-cart-toast pattern, now carrying the
 *      line's name, a View bag link and a dismiss (the shape assets/svnty-wishlist.js already uses,
 *      so the theme has one toast look, not two).
 *   2. THE BAG MARK - #cart-icon-bubble repainted from the add response's own `cart-icon-bubble`
 *      section, so the header's disc is never stale after an in-place add.
 *   3. THE ONE ADD PATH - window.SVNTYCartAdd(formData, source), the shared POST every SVNTY
 *      add-to-bag control can call: it asks for the bubble section, then announces the add on the
 *      theme's bus so 1 and 2 happen by themselves.
 *
 * WHY IT GREW (findings D-1 / D-2 / D-3 / CL-1, PARITY_GAPS 2026-09-19).
 *   D-3: this file subscribed ONLY to Trade's in-memory pubsub (assets/pubsub.js), while the
 *   R3-22 (round 3) CORRECTS THIS NOTE. Of the three roads named below, only svnty-quick-shop.js is
 *   reachable on this store (tagged from sections/svnty-returns-desk.liquid), svnty-buy-popup.js is
 *   never loaded at all (its snippet is rendered 0 times), and svnty-gift-card is page-gated. The
 *   DOM-bus binding is still correct and still cheap - the justification was not.
 *   Horizon-ported roads - svnty-quick-shop.js, svnty-buy-popup.js, svnty-gift-card - dispatch a
 *   DOM CustomEvent('cart:update'). Nothing in Trade listens to that event, so their adds were
 *   silent: no toast, a stale bag count, a free-shipping bar on the old subtotal. THE TWO BUSES
 *   (section 5) now feed ONE handler, so an add is an add whichever road it came down.
 *   D-1 / D-2 / CL-1: with `cart_type: page` there is no <cart-notification> and no <cart-drawer>,
 *   so Trade's product-form fell through to `window.location = /cart` - every add from the PDP, the
 *   sticky bar and every collection card threw the shopper off the page she was on. assets/
 *   product-form.js and assets/svnty-pdp-sticky.js now add IN PLACE and announce it here.
 *
 * WORDS: window.svntyStrings only (H4) - added_to_bag, view_bag, add_error, close. No literal here.
 * SHEET: the ten rules the toast's own layout needs are injected by this file (section 1), because
 * its load point, snippets/svnty-head.liquid, is closed to this lane tonight; the toast's skin
 * (fixed, ink on paper, radius, rise) is already .svnty-toast in assets/svnty-tokens.css and is
 * NOT restated. ASCII only, no deps, ES5.
 */
(function () {
  'use strict';

  var TOAST_MS = 2600;
  var STR = window.svntyStrings || {};

  function routeCart() {
    try {
      if (window.routes && window.routes.cart_url) return window.routes.cart_url;
    } catch (e) {}
    return '/cart';
  }

  function routeAdd() {
    try {
      if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    } catch (e) {}
    return '/cart/add';
  }

  /* ======================================================================== *
   * 1. THE SHEET - layout only. Everything visual is .svnty-toast in the tokens.
   * ======================================================================== */
  function sheet() {
    if (document.querySelector('style[data-svnty-cart-toast-css]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-svnty-cart-toast-css', '');
    s.textContent =
      '.svnty-cart-toast{display:flex;align-items:center;justify-content:space-between;' +
      'gap:var(--svnty-s-4);max-width:560px;margin:0 auto;z-index:100}' +
      '.svnty-cart-toast[hidden]{display:none}' +
      '.svnty-cart-toast__msg{min-width:0;overflow-wrap:anywhere}' +
      '.svnty-cart-toast--wear{flex-wrap:wrap}' +
      '.svnty-cart-toast__wear{flex:1 1 100%;display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:10px;padding-top:10px;border-top:1px solid rgb(var(--svnty-paper) / 0.18)}' +
      '.svnty-cart-toast__wear-h{flex:1 1 100%;margin:10px 0 -4px;font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:rgb(var(--svnty-paper) / 0.7)}' +
      '.svnty-cart-toast__item{display:flex;align-items:center;gap:8px;min-height:44px;color:rgb(var(--svnty-paper));text-decoration:none;font-size:12px;line-height:1.3}' +
      '.svnty-cart-toast__item img{width:40px;height:50px;object-fit:cover;border-radius:4px;flex:none;background:rgb(var(--svnty-paper) / 0.1)}' +
      '.svnty-cart-toast__item span{display:block;min-width:0}' +
      '.svnty-cart-toast__item small{display:block;opacity:0.7;font-size:11px}' +
      '.svnty-cart-toast__action{flex:0 0 auto;color:rgb(var(--svnty-paper));font-size:12px;' +
      'font-weight:500;letter-spacing:var(--svnty-track-caps);text-transform:uppercase;' +
      'text-decoration:underline;text-underline-offset:0.3rem}' +
      'html[lang^="ar"] .svnty-cart-toast__action{text-transform:none;letter-spacing:0}' +
      '.svnty-cart-toast__close{flex:0 0 auto;display:grid;place-items:center;width:24px;' +
      'height:24px;padding:0;border:0;background:none;color:inherit;cursor:pointer;' +
      '-webkit-tap-highlight-color:transparent}' +
      '@media (prefers-reduced-motion: reduce){.svnty-cart-toast{animation:none}}';
    (document.head || document.documentElement).appendChild(s);
  }

  /* ======================================================================== *
   * 2. THE TOAST - one node, reused; window.SVNTYToast.show(message[, action]).
   * ======================================================================== */
  var node = null;
  var timer = null;

  function ensure() {
    if (node && node.isConnected) return node;
    sheet();
    node = document.querySelector('.svnty-toast[data-svnty-cart-toast]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'svnty-toast svnty-cart-toast';
      node.setAttribute('data-svnty-cart-toast', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.hidden = true; document.documentElement.classList.remove('svnty-cart-toast-open');
      document.body.appendChild(node);
      node.addEventListener('click', function (e) {
        if (e.target.closest('[data-svnty-toast-close]')) hide(true);
      });
    }
    return node;
  }

  /* R2-48 law, kept: never yank the node the shopper is standing on. */
  function hide(force) {
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
    if (!node) return;
    if (!force && node.contains(document.activeElement)) {
      timer = window.setTimeout(hide, TOAST_MS);
      return;
    }
    node.hidden = true; document.documentElement.classList.remove('svnty-cart-toast-open');
  }

  /* The toast sits on the phone's bottom edge and so does the PDP's buy bar and the cart page's
     CHECK OUT bar. Measure whatever fixed bar is actually on screen and stand above it, rather than
     hard-coding a height that every one of those bars is free to change. */
  function liftAbove(el) {
    var bars = document.querySelectorAll('.svnty-pdpbar, .svnty-cart-bar, .svnty-sticky-bottom');
    var lift = 0;
    for (var i = 0; i < bars.length; i += 1) {
      var bar = bars[i];
      if (bar === el) continue;
      var box = bar.getBoundingClientRect();
      if (!box.height) continue;
      if (box.bottom < window.innerHeight - 1) continue; /* not anchored to the bottom edge */
      var style = window.getComputedStyle(bar);
      if (style.visibility === 'hidden' || style.display === 'none' || style.opacity === '0') continue;
      if (box.height > lift) lift = box.height;
    }
    el.style.bottom = lift
      ? 'calc(var(--svnty-s-4) + var(--svnty-safe-bottom) + ' + Math.round(lift) + 'px)'
      : '';
  }

  function show(message, action) {
    if (!message) return;
    var el = ensure();
    el.textContent = '';
    el.classList.remove('svnty-cart-toast--wear');

    var msg = document.createElement('span');
    msg.className = 'svnty-cart-toast__msg';
    msg.textContent = message;
    el.appendChild(msg);

    if (action && action.label && action.href) {
      var link = document.createElement('a');
      link.className = 'svnty-cart-toast__action';
      link.href = action.href;
      link.textContent = action.label;
      el.appendChild(link);
    }

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'svnty-cart-toast__close';
    close.setAttribute('data-svnty-toast-close', '');
    close.setAttribute('aria-label', STR.close || '');
    close.innerHTML =
      ((window.SVNTY && SVNTY.iconHTML) ? SVNTY.iconHTML('close', 14, 1.5) : '')  /* THE ICON LAW (D11-3) */;
    el.appendChild(close);

    el.hidden = false; document.documentElement.classList.add('svnty-cart-toast-open');   /* P33-3: the Ask bubble steps aside while the card is the bag's door */
    liftAbove(el);
    void el.offsetWidth; /* reflow so a repeat add re-animates */
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(hide, TOAST_MS);
  }

  window.SVNTYToast = { show: show, hide: hide };

  /* ======================================================================== *
   * 3. THE BAG MARK - #cart-icon-bubble, repainted from the section Shopify renders with the add.
   * Trade's own contract (assets/cart.js getSectionsToRender): id `cart-icon-bubble`, selector
   * `.shopify-section`. assets/svnty-wishlist.js already adds this way; this is the same idiom.
   * ======================================================================== */
  function sectionInner(markup) {
    try {
      var found = new DOMParser().parseFromString(markup, 'text/html').querySelector('.shopify-section');
      return found ? found.innerHTML : null;
    } catch (e) {
      return null;
    }
  }

  function paintBag(markup) {
    var bag = document.getElementById('cart-icon-bubble');
    if (!bag || !markup) return false;
    var inner = sectionInner(markup);
    if (inner == null) return false;
    bag.innerHTML = inner;
    return true;
  }

  var asking = false;
  function askBag() {
    /* the road that carries no sections (a DOM cart:update from a ported Horizon script): ask the
       server for the same section rather than patching the disc by hand - the disc's visually-hidden
       "n items" sentence beside it must stay true too. */
    if (asking || !document.getElementById('cart-icon-bubble')) return;
    asking = true;
    fetch(routeCart() + '?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        var bag = document.getElementById('cart-icon-bubble');
        if (!bag || !html) return;
        var inner = sectionInner(html); /* ?section_id= answers inside the .shopify-section wrapper */
        if (inner == null || inner.indexOf('data-svnty-cart-count') < 0) return; /* P27-3 (audit P1-5): never paint a page that is not the bag */
        bag.innerHTML = inner;
      })
      .catch(function () {})
      .then(function () {
        asking = false;
      });
  }

  function refreshBag(sections) {
    if (paintBag(sections && sections['cart-icon-bubble'])) return;
    askBag();
  }

  /* ======================================================================== *
   * 4. THE ONE HANDLER - what an add does, whichever bus carried it.
   * ======================================================================== */
  function isAdd(payload) {
    var src = payload && payload.source;
    /* R3-28 (round 3): `assets/quick-add-bulk.js:135,174` publishes `{ source: 'quick-add' }` and the
       gate silently dropped it - verified in-browser, 0 toasts. Inert today (bulk quick-add is not
       enabled on any template), a trap the day it is. Named, not guessed at. */
    if (src === 'product-form' || src === 'quick-add') return true;
    return typeof src === 'string' && src.indexOf('svnty-') === 0;
  }

  /* SOURCES THAT SPEAK FOR THEMSELVES. assets/svnty-wishlist.js raises its own .svnty-wl-toast
     with the same sentence and the same View bag link, and repaints the bag mark itself. Two
     toasts at one fixed position is one toast covering another, so this layer stays quiet for it
     and only lets the bag repaint through (idempotent). */
  function speaksForItself(payload) {
    return payload && payload.source === 'svnty-wishlist';
  }

  function titleFor(payload) {
    var cart = payload && payload.cartData;
    var vid = payload && (payload.productVariantId || payload.variantId);
    if (!cart) return null;
    /* the add response carries the added line at cart.items[] (full cart) or as cart.title (line) */
    if (Array.isArray(cart.items) && vid) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].id) === String(vid)) {
          return cart.items[i].product_title || cart.items[i].title || null;
        }
      }
    }
    return cart.product_title || cart.title || null;
  }

  /* THE TOAST'S SENTENCE (D5-3, C-21, A RULED): "Hoodie in Olive, size M, added to bag", the piece as the shopper chose it
     and no dash of any kind; the words are the locale's (window.svntyStrings.qa, snippets/svnty-qa-strings.liquid) */
  /* THE STRIPE NAME (D8-8, R239): the colour as the page printed it for this piece ("Blue stripe"), read from the markup the
     server wrote: the picker's colour inputs (data-svnty-name, the product page and the door), a card's swatch buttons, a
     card's quick-add data (dn); a piece the page does not show prints its value */
  function colourName(handle, value) {
    if (!handle || !value) return value;
    var tail = '/products/' + handle, i, j;
    function isMine(u) { u = String(u || '').split('?')[0]; return u.slice(-tail.length) === tail; }
    var pickers = document.querySelectorAll('variant-selects[data-url]');
    for (i = 0; i < pickers.length; i++) {
      if (!isMine(pickers[i].getAttribute('data-url'))) continue;
      var named = pickers[i].querySelectorAll('input[data-svnty-name], option[data-svnty-name]');
      for (j = 0; j < named.length; j++) if (named[j].value === value) return named[j].getAttribute('data-svnty-name') || value;
    }
    var cards = document.querySelectorAll('.card-wrapper');
    for (i = 0; i < cards.length; i++) {
      var a = cards[i].querySelector('a[href*="/products/"]');
      if (!a || !isMine(a.getAttribute('href'))) continue;
      var sws = cards[i].querySelectorAll('.svnty-card__sw[data-svnty-name]');
      for (j = 0; j < sws.length; j++) if (sws[j].getAttribute('data-colour') === value) return sws[j].getAttribute('data-svnty-name') || value;
      var q = cards[i].querySelector('[data-svnty-qa-json]'), d = null;
      try { d = q ? JSON.parse(q.getAttribute('data-svnty-qa-json')) : null; } catch (e) { d = null; }
      if (d && d.d === value && d.dn) return d.dn;
    }
    return value;
  }

  function lineWords(payload, title) {
    if (!title) return '';
    var Q = (window.svntyStrings && window.svntyStrings.qa) || {};
    var cart = payload && payload.cartData, vid = payload && (payload.productVariantId || payload.variantId), line = cart;
    if (cart && Array.isArray(cart.items)) {
      line = null;
      for (var i = 0; i < cart.items.length; i++) if (String(cart.items[i].id) === String(vid)) { line = cart.items[i]; break; }
    }
    var colour = '', size = '', other = [];
    ((line && line.options_with_values) || []).forEach(function (o) {
      var n = String(o.name || '').toLowerCase();
      if (n.indexOf('colour') >= 0 || n.indexOf('color') >= 0) colour = o.value;
      else if (n.indexOf('size') >= 0) size = o.value;
      else if (o.value && o.value !== 'Default Title') other.push(o.value);
    });
    var item = title;
    if (colour) colour = colourName(line && line.handle, colour);
    if (colour) item = (Q.item_in_colour || '[title] in [colour]').replace('[title]', item).replace('[colour]', colour);
    if (size) item = (Q.item_size || '[item], size [size]').replace('[item]', item).replace('[size]', size);
    if (other.length) item += ', ' + other.join(', ');
    return (Q.toast_line || '[item], added to bag').replace('[item]', item);
  }

  /* R115 line 3 (D2-31): THE POST-ADD CROSS-SELL. The added line's product id is in the add response; the two
     curated complementary pieces (Search & Discovery, intent=complementary) are fetched and set under the
     message as two small links. No new surface: the same toast, a little taller, for a little longer. */
  function productIdFor(payload) {
    var cart = payload && payload.cartData;
    var vid = payload && (payload.productVariantId || payload.variantId);
    if (!cart) return null;
    if (Array.isArray(cart.items) && vid) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].id) === String(vid)) return cart.items[i].product_id || null;
      }
    }
    return cart.product_id || null;
  }
  function money(cents) {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents, (window.svntyMoneyFormat || '{{amount}}'));
    } catch (e) {}
    return 'EGP ' + (cents / 100).toLocaleString('en-EG', { minimumFractionDigits: 2 });
  }
  function wearWith(productId) {
    var el = ensure();
    if (!productId || !el || el.hidden) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&intent=complementary&limit=2', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var items = (d && d.products) || [];
        if (!items.length || el.hidden) return;
        var h = document.createElement('span');
        h.className = 'svnty-cart-toast__wear-h';
        h.textContent = STR.wear_with || 'Wear it with';
        var row = document.createElement('div');
        row.className = 'svnty-cart-toast__wear';
        items.slice(0, 2).forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'svnty-cart-toast__item';
          a.href = p.url;
          var img = document.createElement('img');
          img.alt = ''; img.loading = 'lazy'; img.width = 40; img.height = 50;
          if (p.featured_image) img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_120x150$1$2');
          var t = document.createElement('span');
          t.textContent = p.title;
          var s = document.createElement('small');
          s.textContent = money(p.price);
          t.appendChild(s);
          a.appendChild(img); a.appendChild(t); row.appendChild(a);
        });
        el.classList.add('svnty-cart-toast--wear');
        el.appendChild(h); el.appendChild(row);
        liftAbove(el);
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(hide, TOAST_MS + 3400);
      })
      .catch(function () {});
  }
  function onAdd(payload) {
    if (!isAdd(payload)) return; /* a qty change is not an add */
    if (payload && payload.cartData && payload.cartData.status) return; /* Shopify error body */
    if (payload && payload.didError) return;

    refreshBag(payload.sections || (payload.cartData && payload.cartData.sections));
    if (speaksForItself(payload)) return;

    var title = titleFor(payload);
    var added = STR.added_to_bag || '';
    if (!added) return;
    var line = lineWords(payload, title);
    /* P17-26 (eye pass R2 P2-4): on the bag its own lines show the add (assets/cart.js renderBag), so no toast and no VIEW BAG
       lies over its rails; the sentence the toast spoke goes to the bag's live region, which stays (a card's own live line
       leaves with the card when COMPLETES YOUR BAG gives up the piece it just added) */
    if (document.querySelector('#MainContent cart-items')) {
      var said = document.getElementById('cart-live-region-text');
      if (said) { said.setAttribute('aria-hidden', 'false'); said.textContent = line || added; }
      return;
    }
    show(line || added, {
      label: STR.view_bag || '',
      href: routeCart()
    });
    wearWith(productIdFor(payload));
  }

  /* ======================================================================== *
   * 5. THE TWO BUSES (D-3). Trade's in-memory pubsub carries product-form, cart-items, quick-add
   * and every SVNTY script that publishes; the DOM CustomEvent('cart:update') carries the roads
   * ported from Horizon. One handler, one shape.
   * ======================================================================== */
  function fromDom(event) {
    var detail = (event && event.detail) || {};
    var data = detail.data || {};
    onAdd({
      source: data.source || detail.sourceId,
      productVariantId: data.variantId || detail.sourceId,
      cartData: detail.resource,
      sections: data.sections,
      didError: data.didError
    });
  }

  /* THE SVNTY-NAMED EVENT. assets/svnty-wishlist.js (lane L) announces its add as
     `svnty:cart:added` on document — a DOM event on purpose, so a listener that loads after the
     dispatcher still hears every later add. Honoured here as the third road into the one handler.
     Its own source, `svnty-wishlist`, raises its own toast, so this repaints the bag mark and
     stays quiet; any other road that adopts the name gets the whole treatment. */
  function fromSvnty(event) {
    var d = (event && event.detail) || {};
    onAdd({
      source: d.source || 'svnty-add',
      productVariantId: d.variantId,
      cartData: d.cartData || d.response,
      sections: (d.cartData || d.response || {}).sections,
      didError: d.didError
    });
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object' || !PUB_SUB_EVENTS.cartUpdate) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onAdd);
    /* P20: a refusal can still have added pieces (three asked, two in stock: the store adds the two and answers 422), so after
       any add error the bag mark asks the server and never stays stale */
    if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError, function () { askBag(); });
    return true;
  }

  document.addEventListener('cart:update', fromDom);
  document.addEventListener('svnty:cart:added', fromSvnty);

  /* constants.js + pubsub.js are deferred in theme.liquid's head, so they are parsed before this
     deferred script runs; the DOMContentLoaded retry is the belt for a bfcache restore. */
  if (!bindPubSub()) document.addEventListener('DOMContentLoaded', bindPubSub, { once: true });

  /* ======================================================================== *
   * 6. THE ONE ADD PATH - window.SVNTYCartAdd(formData, source) -> Promise<{ok, data, message}>.
   * Asks for the bubble section, publishes the add on the theme's bus (which raises the toast and
   * repaints the bag through section 4), and NEVER navigates. A caller that already ran its own
   * POST announces with window.SVNTYCartAnnounce instead.
   * ======================================================================== */
  function announce(source, variantId, data) {
    var payload = {
      source: source || 'svnty-add',
      productVariantId: variantId ? String(variantId) : null,
      cartData: data
    };
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, payload);
        return;
      }
    } catch (e) {}
    onAdd(payload); /* no bus on this page: the feedback still happens */
  }

  window.SVNTYCartAnnounce = announce;

  window.SVNTYCartAdd = function (body, source) {
    var form = body instanceof FormData ? body : new FormData();
    if (!form.has('sections')) form.append('sections', 'cart-icon-bubble');
    if (!form.has('sections_url')) form.append('sections_url', window.location.pathname);

    var opts = {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: form,
      credentials: 'same-origin'
    };
    /* THE WALL, when the page carries it (assets/svnty-wall.js): a never-settling add must not
       leave a button spinning for ever. The `? :` arm degrades to no wall, never to a TypeError. */
    var done = window.svntyWall ? window.svntyWall(opts, 12000) : function () {};

    /* P28 lane E (cart P2-4): a 429 / 503 add is asked again once (svntyAddFetch, global.js); a refused answer is an error, not JSON */
    return (typeof svntyAddFetch === 'function' ? svntyAddFetch(routeAdd(), opts) : fetch(routeAdd(), opts).then(function (r) { return r.json(); }))
      .then(function (data) {
        if (!data || data.status) {
          return {
            ok: false,
            data: data || null,
            message: (data && (data.description || data.message)) || STR.add_error || ''
          };
        }
        announce(source, form.get('id'), data);
        return { ok: true, data: data, message: '' };
      })
      .catch(function () {
        return { ok: false, data: null, message: STR.add_error || '' };
      })
      .then(function (result) {
        done();
        return result;
      });
  };
})();
